import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/activities";
import filterAct from "../../models/workflow/filterAct";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    activities: [],
    filter: {},
    editFilter: {},
    checkTo: true,
    dateFrom: null,
    dateTo: null,
    newActivities: {},
    itemsSelected: [],
    changeEvent: true,
    undo: [],
    newScheduleAct: {},
    newLicAct: {},
    coments: [],
    filesAct: [],
    licenseConcepts: [],
    employees: [],
  },

  mutations: {
    setActivities(state, data) {
      state.activities = data;
    },
    setFilter(state, data) {
      state.filter = data;
    },
    setFilesAct(state, data) {
      state.filesAct = data;
    },
    setEditFilter(state, data) {
      state.editFilter = data;
    },
    setCheckTo(state, data) {
      state.checkTo = data;
    },
    setDateFrom(state, data) {
      state.dateFrom = data;
    },
    setDateTo(state, data) {
      state.dateTo = data;
    },
    setNewActivities(state, data) {
      state.newActivities = data;
    },
    setItemsSelected(state, data) {
      state.itemsSelected = data;
    },
    setUndo(state, data) {
      state.undo = data;
    },
    setChangeEvent(state, data) {
      state.changeEvent = data;
    },
    setNewScheduleAct(state, data) {
      state.newScheduleAct = data;
    },
    setNewLicAct(state, data) {
      state.newLicAct = data;
    },
    setComents(state, data) {
      state.coments = data;
    },
    setLicenseConcepts(state, data) {
      state.licenseConcepts = data;
    },
    setEmployees(state, data) {
      state.employees = data;
    },
  },
  actions: {
    async getLicenseConcepts(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLicenseConcepts();
          state.commit("setLicenseConcepts", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getEmployees(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getEmployees();
          state.commit("setEmployees", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getActivities(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getActivities();
          state.commit("setActivities", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getFilter(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getFilter();
          if (item.operId == undefined) {
            state.commit("setFilter", state.state.filter);
          } else {
            state.commit("setFilter", item);
            state.commit("setCheckTo", item.to === null);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    //retorna los documentos adjuntos de una actividad
    async getFiles(state, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getFiles(payload);
          state.commit("setFilesAct", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async editFilter(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = state.state.editFilter;
          await state.state.service
            .saveFilter(state.state.editFilter)
            .then(() => {
              item = filterAct.fromJson({
                operId: item.operId,
                fecDesde: item.from,
                fecHasta: item.to,
                mios: item.mine,
                pendientes: item.pendings,
                aprobadas: item.approved,
                rechazadas: item.reject,
                licencias: item.licens,
                cHorario: item.schedules,
                hsExtra: item.hsExtra,
                licF: item.licF,
                dele: item.dele,
                columnas: item.columnas,
              });
              state.commit("setFilter", item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async newActivities(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.newAct(
            state.state.newActivities
          );

          state.commit("setNewActivities", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async undo(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.undo(state.state.undo);

          state.commit("setUndo", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async newScheduleAct(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.newScheduleAct(
            state.state.newScheduleAct
          );
          state.commit("setNewScheduleAct", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async newLicAct(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.newLicAct(state.state.newLicAct);
          state.commit("setNewLicAct", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getComents(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getComents();
          state.commit("setComents", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
